import { render } from "./DialogCustomer.vue?vue&type=template&id=69933580"
import script from "./DialogCustomer.vue?vue&type=script&lang=js"
export * from "./DialogCustomer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__